<template>
    <div v-if="display">
        <div
            id="maintenancebubble"
            class="bg-white border"
        >
            <div class="bg-primary circle">
                <i
                    :class="icon"
                    class="fa-solid text-white"
                ></i>
            </div>
            <div
                id="text"
                class="px-3"
            >
                {{ text }}
            </div>
        </div>
    </div>
</template>

<style>
.circle {
    border-radius: 2rem;
    height: 3rem;
    width: 3rem;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#maintenancebubble {
    border-radius: 2rem;
    display: flex;
    width: fit-content;
}

#text {
    display: flex;
    align-items: center;
}
</style>

<script>
import eventbus from "@eventbus";
export default {
    name: "MaintenanceNotification",
    data() {
        return {
            display: false,
            type: "update",
        };
    },
    computed: {
        icon() {
            if (this.type === "update") {
                return "fa-cloud-arrow-down";
            }

            if (this.type === "demo") {
                return "fa-rocket";
            }

            return "fa-screwdriver-wrench";
        },
        text() {
            if (this.type === "update") {
                return "Update bezig...";
            }

            if (this.type === "demo") {
                return "Demo omgeving";
            }

            return "Onderhoud bezig...";
        },
    },
    mounted() {
        eventbus.on("maintenance-show", this.set_display);
        eventbus.on("maintenance-type", this.set_type);
    },
    unmounted() {
        eventbus.off("maintenance-show", this.set_display);
        eventbus.off("maintenance-type", this.set_type);
    },
    methods: {
        set_display(val) {
            this.display = val;
        },
        set_type(val) {
            this.type = val;
        },
    },
};
</script>
